// material-ui
import {} from '@mui/material'
import React from 'react'

import { Grid } from '@mui/material'
import * as SC from 'features/shared_components'
import { Chart } from 'react-google-charts'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'

import { gridSpacing } from 'store/constant'

import { ReleaseActionType } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import { get_all_coherentScreen } from 'features/coherentScreen/coherentScreen-slice'
import { get_all_curatedMediaList } from 'features/curatedMediaList/curatedMediaList-slice'
import { get_all_curatedSeriesList } from 'features/curatedSeriesList/curatedSeriesList-slice'
import { get_all_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import { CoherentScreen, CuratedMediaList, ReleaseScheduleAction } from 'models'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let coherentScreen_list = useSelector(get_all_coherentScreen)
  let curatedMediaList_list = useSelector(get_all_curatedMediaList)
  let curatedSeriesList_list = useSelector(get_all_curatedSeriesList)
  let releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction)
  const [modelChanges, setModelChanges] = React.useState(null)
  const [modelValid, setModelValid] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [modelDirty, setModelDirty] = React.useState(null)

  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.get_coherent_screen_list_for_system_schedules({ ok: false }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.load_curated_media_list_for_system_schedules({ ok: false }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.load_curated_series_list_for_system_schedules({ ok: false }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_system_schedules({
          ok: false,
        }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_media_for_system_schedules({ ok: false }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_series_for_system_schedules({ ok: false }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_seasons_for_system_schedules({ ok: false }))
    }
  }, [claims?.user])

  function addCoherentScreenSubparsts(data: any[], cs: CoherentScreen) {
    cs?.orderedReferenceList?.forEach((item) => {
      let rsa: ReleaseScheduleAction[] | null = null
      let id: string = ''
      let name: string = ''
      let cm = curatedMediaList_list.find((v) => v.id === item)
      if (cm) {
        id = `${cm.name}`
        name = `${cm.name}`
        rsa = releaseScheduleAction_list.filter(
          (v) => v.enabled && v.curatedMediaListId === cm?.id,
        )
        addMediaRelease(data, cm)
      } else {
        let curatedSeriesListItem = curatedSeriesList_list.find(
          (v) => v.id === item,
        )
        if (curatedSeriesListItem) {
          id = `${cs.id}#${curatedSeriesListItem.id}`
          name = `${curatedSeriesListItem.name}`
          rsa = releaseScheduleAction_list.filter(
            (v) =>
              v.enabled && v.curatedSeriesListId === curatedSeriesListItem?.id,
          )
        }
      }
      if (rsa) {
        let { startDate, endDate } = pullDates(rsa)
        if (id && startDate && endDate) {
          data.push([name, startDate, endDate])
        }
      }
    })
  }

  function pullDates(releaseActions: ReleaseScheduleAction[]) {
    let releaseStart = releaseActions.find(
      (v) => v?.releaseActionType === ReleaseActionType.ScheduledRelease,
    )
    let releaseEnd = releaseActions.find(
      (v) => v?.releaseActionType === ReleaseActionType.ScheduledUnrelease,
    )
    if (releaseStart) {
      let startDate = SC.decipherDate(releaseStart.releaseDate)
      let endDate = releaseEnd
        ? SC.decipherDate(releaseEnd.releaseDate)
        : SC.addDays(new Date(), 5 * 365)
      let temp = startDate
      if (startDate > endDate) {
        startDate = endDate
        endDate = temp
      }
      return {
        startDate,
        endDate,
      }
    }
    return { startDate: null, endDate: null }
  }

  function addMediaRelease(data: any[], cm: CuratedMediaList) {
    cm?.media?.forEach((item) => {
      let rsa = releaseScheduleAction_list.filter(
        (v) => v.enabled && v.mediaId === item?.id,
      )
      if (rsa) {
        let { startDate, endDate } = pullDates(rsa)
        if (item?.name && startDate && endDate) {
          data.push([item.name, startDate, endDate])
        }
      }
    })
  }

  function modelComponent(): any {
    return (() => {
      if (!coherentScreen_list || coherentScreen_list?.length === 0) {
        return <></>
      }
      const options = {
        timeline: { groupByRowLabel: false },
        height: `calc(100vh - 200px)`,
        gantt: {
          trackHeight: 30,
        },
      }
      const columns = [
        { type: 'string', id: 'Name' },
        { type: 'date', id: 'Start' },
        { type: 'date', id: 'End' },
      ]
      let data = [columns]
      coherentScreen_list?.forEach((cs) => {
        let releaseStart = releaseScheduleAction_list.find(
          (v) =>
            v.enabled &&
            v.coherentScreenId === cs?.id &&
            v?.releaseActionType === ReleaseActionType.ScheduledRelease,
        )
        let releaseEnd = releaseScheduleAction_list.find(
          (v) =>
            v.enabled &&
            v.coherentScreenId === cs?.id &&
            v?.releaseActionType === ReleaseActionType.ScheduledUnrelease,
        )
        if (releaseStart) {
          let startDate = SC.decipherDate(releaseStart.releaseDate)
          let endDate = releaseEnd
            ? SC.decipherDate(releaseEnd.releaseDate)
            : SC.addDays(new Date(), 5 * 365)
          let temp = startDate
          if (startDate > endDate) {
            startDate = endDate
            endDate = temp
          }
          data.push([cs?.name, startDate, endDate])
          addCoherentScreenSubparsts(data, cs)
        }
      })
      return (
        <>
          <Chart
            chartType="Timeline"
            width="100%"
            data={data}
            options={options}
          />
        </>
      )
    })()
  }

  let output_modelComponent = modelComponent()

  function main_card(modelList: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <MainCard title={TitleService('Coherent Screens')}>
            {modelList}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_modelComponent)

  return output_main_card
}
